import React from "react";
import style from "./NewScreen.module.scss";
import awesomeleft from "../../../../../assets/images/awesome-arrow-left.svg";
import dollorS from "../../../../../assets/images/dollorS.svg";

function NewScreen({ handleActiveTab }) {
  return (
    <div className={style.container}>
      <div className={style.Wrapper}>
        <div>
          <img
            src={awesomeleft}
            onClick={() => handleActiveTab(0)}
            alt="left"
          />
        </div>

        <div className={style.subWrapper}>
          <div className={style.imgWrapper}>
            <img src={dollorS} alt="Dollor" />
            <div className={style.text}>0.00 USDa</div>
          </div>
          <div className={style.textWrapper}>
            <div className={style.subtextWrapper}>
              <div className={style.subtext1}>STAKING</div>
              <div className={style.subtext2}>0.0000 ACX</div>
            </div>
            <div className={style.border}></div>
            <div className={style.subtextWrapper}>
              <div className={style.subtext1}>GAS PRICE (GWEI)</div>
              <div className={style.subtext2}>
                = 0 <span>EDIT</span>
              </div>
            </div>
            <div className={style.border}></div>
            <button>Mint USDa</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewScreen;
